<!-- 设备管理-生产列表-配置主板 -->
<template>
  <!-- 模板一，不改变面包屑 -->
  <div class="mainArea ConfigMainboard">
    <!-- 主要头部内容 -->
    <div class="mainHeadContent">
      <!-- 面包屑 -->
      <BreadCrumb></BreadCrumb>
      <!-- config信息 -->
      <div class="configInfo">
        <span class="info">设备ID：{{deviceInfo.device_no_id}}</span>
        <span class="info">设备类型：{{deviceInfo.device_name}}</span>
        <span class="info">所属企业：{{deviceInfo.company_name}}</span>
      </div>
    </div>
    <!--主内容区-->
    <div class="mainBodyContent">
      <!-- 按钮区域 -->
      <div class="btnArea clearfix">
        <el-button class="configBtn" @click="configBoard">配置主板</el-button>
        <el-button class="openDoorBtn" @click="operDoor">一键开门</el-button>
        <el-button class="viewInfoBtn" @click="getBoxInfo">查看信息</el-button>
        <el-button class="backBtn" @click="back">返 回</el-button>
      </div>

      <!-- 数据区域 -->
      <div class="dataWrapper">
        <!-- 数据框 -->
        <div class="dataBox" v-html="dataBox">
          <!-- <p
            class="text"
            v-for="(item, index) in dataBox"
            :key="index">{{item}}</p> -->
        </div>
        
        <!-- 加载中 -->
        <div class="loading clearfix" v-if="loading.isShow">
          <img class="icon" src="../../../../../static/images/icon/loading.gif" alt="">
          <span class="msg">{{loading.msg}}</span>
        </div>
      </div>


      <!-- 对话框 -->
      <el-dialog
        :title="dialogData.title" 
        :visible.sync="dialogData.visible"
        :show-close="dialogData.title === '' ? false : true">
        
        <!-- 柜类表格信息 -->
        <div v-if="dialogData.type === 'viewInfo'">
          <el-table
            class="cabinetsList"
            :data="dialogData.info"
            :cell-style="setCellStyle"
            :header-cell-style="setCellStyle"
            border>
            <el-table-column
              type="index"
              label="序号"
              width="60">
            </el-table-column>
            <el-table-column
              prop="box_number"
              label="编号">
            </el-table-column>
            <el-table-column
              prop="device_name"
              label="类型">
            </el-table-column>
            <el-table-column
              prop="box_size"
              label="大小"
              v-if="dialogData.showSize">
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import BreadCrumb from "../../../Layout/BreadCrumb.vue"
  import { deviceApi } from '../../../../../static/js/api';
  import { showToast, storage } from '../../../../../static/js/utility/utility';

  export default {
    name: 'ConfigMainboard',
    components: {
      BreadCrumb
    },
    data() {
      return {
        // 设备信息
        deviceInfo: {},
        // 对话框数据
        dialogData:{
          type: '',
          title: '',
          visible: false,
          showSize: false,
          info: {}
        },
        // 数据框数据
        dataBox: '',
        // 加载数据
        loading: {
          isShow: false,
          msg: ''
        }
      }
    },
    mounted(){
      // 获取设备信息
      console.log('storage', storage.sessionGetItem('deviceInfo'))
      this.deviceInfo = storage.sessionGetItem('deviceInfo')
      console.log(' this.deviceInfo ', this.deviceInfo )
    },
    created: async function () {
    },
    destroyed() {
      // 关闭页面清除本地存储的设备信息
      storage.sessionRemoveItem('deviceInfo')
    },
    methods: {
      // 显示加载中
      showLoading: function (msg) {
        this.loading = {
          isShow: true,
          msg: msg
        }
      },
      // 隐藏加载中
      hideLoading: function () {
        this.loading.isShow = false
      },
      // 处理数据框数据
      processDataBox: function (data) {
        let vm = this
        vm.dataBox = ''
        let i = 0;
        let t= setInterval (function () {
          vm.dataBox += '<p class="text">'+ data[i] + '</p>'
          i = i + 1
          //如果超过数组长度，清除定时器
          if(i >= data.length){
            vm.hideLoading()
            clearInterval(t)
          }
        },500)
        console.log('vm.dataBox', vm.dataBox)
      },
      // 配置主板
      configBoard: async function () {
        let vm = this
        let data = {
          device_no_id: this.deviceInfo.device_no_id
        }

        vm.showLoading('配置中...')
        let res = await deviceApi.configBoard(data)
        if (res.meta.code === 200) {
          console.log('res', res)
          vm.processDataBox(res.data)
        } else {
          vm.hideLoading()
          showToast(res.meta.message)
        }
      },
      // 一键开门
      operDoor: async function () {
        let vm = this
        let data = {
          device_no_id: this.deviceInfo.device_no_id
        }

        vm.showLoading('测试中...')
        let res = await deviceApi.operDoor(data)
        if (res.meta.code === 200) {
          console.log('res', res)
          vm.dataBox = res.data
        } else {
          vm.hideLoading()
          showToast(res.meta.message)
        }
      },
      // 操作对话框信息（添加或修改）dialogData
      operateDialogInfo: function (type, info) {
        this.dialogData = {
          type: type,
          title: type === 'viewInfo' ? '查看信息' : '',
          visible: !(this.dialogData.visible),
          showSize: type === 'viewInfo' && info[0].box_size ? true : false,
          info: info ? info : ''
        }
        console.log('this', this.dialogData)
      },
      // 获取设备表格信息
      getBoxInfo: async function () {
        let vm = this
        let data = {
          device_no_id: this.deviceInfo.device_no_id
        }
        console.log('data', data)

        let res = await deviceApi.getBoxInfo(data)
        if (res.meta.code === 200) {
          console.log('res', res)
          // 显示对话框表格
          vm.operateDialogInfo('viewInfo', res.data)
        } else {
          showToast(res.meta.message)
        }

      },
      // 设置单元格样式(表头和序号那一列)
      setCellStyle: function ({row, column, rowIndex, columnIndex}) {
        // console.log('row', row)
        // console.log('column', column)
        // console.log('rowIndex', rowIndex)
        // console.log('columnIndex', columnIndex)
        if ((!row.box_number && rowIndex === 0) ||  columnIndex === 0) {
          return {backgroundColor: '#F5F7FA'}
        } else {
          return {}
        }
      },
      // 返回上一页
      back: function () {
        // 返回生产列表显示tab
        this.$store.state.outputSuccessShowTab = 'output'
        this.$router.go(-1)
      }
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
      }
    }
  }
</script>

<style lang="scss" scoped>
.ConfigMainboard {
  .configInfo {
    margin-top: 25px;
    .info {
      margin-right: 30px;
      font-weight: bold;
    }
  }
  .btnArea {
    height: 40px;
    .configBtn,
    .openDoorBtn,
    .viewInfoBtn {
      float: left;
    }
    .backBtn {
      float: right;
    }
  }
  .dataWrapper {
    position: relative;
    .dataBox {
      width: 500px;
      min-height: 300px;
      padding: 5px;
      margin-top: 20px;
      color: #ffffff;
      font-size: 14px;
      line-height: 24px;
      background-color: #000000;
      box-shadow: 1px 1px 1px #000000, -1px -1px 1px #000000;
    }
    .loading{
      width: 110px;
      line-height: 40px;
      border: 1px solid #cccccc;
      border-radius: 3px;
      background-color: #ffffff;
      position: absolute;
      top: -44px;
      left: 0;
      right: 0;
      margin: auto;
      z-index: 10;
      .icon {
        float: left;
        width: 40px;
        margin-right: 5px;
      }
      .msg {
        float: left;
        font-size: 14px;
      }
    }
  }
  
}
</style>



// WEBPACK FOOTER //
// src/components/Page/DeviceManage/ProductList/ConfigMainboard.vue